<app-breadcrumb></app-breadcrumb>
<section class="section my-3">
    <div class="container">
        <div class="row">
            <div class="col">
                <div class="card mb-3">
                    <div class="card-body">
                        <h1 class="h5 text-default fw-bold border-bottom pb-3 mb-3">Vacant Post</h1>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-info">
                            <span class="fw-bold">Note:</span> Shown vacancies are tentative as on date, it may
                            vary during the allotment. Allotment will
                            be done based on available vacancies at the time of allotment.
                        </div>

                        <div class="row g-3">
                            <div class="col-2">
                                <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.regionId"
                                    #regionId="ngModel" (change)="getStates($event.target.value)">
                                    <option value="" selected>--SELECT REGION--</option>
                                    <option *ngFor="let item of regions" [value]="item.value">{{ item.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-2">
                                <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.stateId" #stateId="ngModel"
                                    (change)="getDistricts($event.target.value)">
                                    <option value="" selected>--SELECT STATE--</option>
                                    <option *ngFor="let item of states" [value]="item.value">{{ item.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-2">
                                <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.districtId"
                                    #districtId="ngModel" (change)="getSchools($event.target.value)">
                                    <option value="" selected>--SELECT DISTRICT--</option>
                                    <option *ngFor="let item of districts" [value]="item.value">{{ item.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-2">
                                <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.schoolId"
                                    #schoolId="ngModel">
                                    <option value="" selected>--SELECT SCHOOL--</option>
                                    <option *ngFor="let item of schools" [value]="item.value">{{ item.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-2">
                                <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.designationId"
                                    #designationId="ngModel">
                                    <option value="" selected>--SELECT DESIGNATION--</option>
                                    <option *ngFor="let item of designations" [value]="item.value">{{ item.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-2">
                                <button type="button" class="btn btn-success" (click)="filter()">Search</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <app-loader [show]="loading"></app-loader>
                        <div [class.d-none]="loading">
                            <div *ngIf="queryResult.items" class="table-responsive">
                                <table class="table align-items-center table-hover">
                                    <colgroup>
                                        <col style="width: 20%">
                                        <col style="width: 20%">
                                        <col style="width: 20%">
                                        <col style="width: 20%">
                                        <col style="width: 20%">
                                    </colgroup>
                                    <thead class="table-light">
                                        <tr>
                                            <th *ngFor="let c of columns">
                                                <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        {{ c.title }}
                                                        <div class="ml-2">
                                                            <i *ngIf="query.sort === c.key" class="fas"
                                                                [class.fa-sort-down]="query.sortDir == 'Ascending'"
                                                                [class.fa-sort-up]="query.sortDir == 'Descending'"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div *ngIf="!c.isSortable">
                                                    {{ c.title }}
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let v of queryResult.items; let i=index;">
                                            <td>{{ (queryResult.pageSize * queryResult.pageNumber + i) - 9 }}</td>
                                            <td>{{ v.sanctionedPost?.school?.name }}</td>
                                            <td>{{ v.sanctionedPost?.designation?.name }}</td>
                                            <td>{{ v.vacancyType?.name }}</td>
                                            <td>{{ v.noOfPost }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page"
                                [page-size]="query.pageSize">
                            </pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>